import { defineRecipe } from '@chakra-ui/react';

// Same v3 re-anchoring already corrected for Input in ./input.ts, on the addon
// half of a joined field. v2's InputAddon matched the Input it sat next to —
// fontSize md (16px), px 4. v3's stock addon is textStyle sm (14px), px 3, so
// after fixing Input alone a joined field rendered its label two pixels smaller
// than its value. Measured on the portal system before this recipe existed:
// input md -> --chakra-font-sizes-md, inputAddon md -> --chakra-font-sizes-sm.
//
// Overriding `md` merges into the stock entry rather than replacing it, so
// stock's `--input-height: sizes.10` still applies and the geometry is
// unchanged. `lineHeight: normal` for the same reason as in ./input.ts —
// textStyle md brings 1.5rem, which v2 never set.
const inputAddonRecipe = defineRecipe({
  variants: {
    size: {
      md: {
        textStyle: 'md',
        lineHeight: 'normal',
        px: '4',
        borderRadius: 'md',
      },
    },
  },
});

export default inputAddonRecipe;
